<h2 mat-dialog-title class="">{{ ctx.title | translate }}</h2>

<mat-dialog-content>
  @if (!ctx.loading) {
    @if (!ctx.rawText) {
      <p>{{ ctx.text | translate }}</p>
    }
    @if (ctx.rawText) {
      <div [innerHTML]="ctx.text"></div>
    }
    @if (ctx.hint) {
      <p class="dialog-hint">{{ ctx.hint | translate }}</p>
    }
  }

  @if (ctx.loading) {
    <div class="loading-state">
      <mat-spinner diameter="40" />
      <span class="loading-text">{{ ctx.loadingText || ctx.text | translate }}</span>
    </div>
  }
</mat-dialog-content>

@if (!ctx.loading) {
  <mat-dialog-actions class="w-full flex justify-between">
    @if (!ctx.noConfirm) {
      <button mat-flat-button mat-dialog-close class="bg-tw-lightgrey flex-grow"><span class="">{{ 'CANCEL' | translate }}</span></button>
    }
    @if (ctx.later) {
      <button mat-flat-button [mat-dialog-close]="'later'" class="bg-tw-mediumgrey text-tw-text-light flex-grow"><span>{{ ctx.later | translate }}</span></button>
    }
    <button mat-flat-button [mat-dialog-close]="'now'" class="bg-tw-primary text-tw-text-light flex-grow"><span class="">{{ ctx.valid | translate}}</span></button>
  </mat-dialog-actions>
}
